
import React from 'react';

import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';


function Dieta(props) {

  const [nome, setNome] = React.useState("");
  const [dieta, setDieta] = React.useState("tutto");
  const [note, setNote] = React.useState("");
  const [allergieText, setAllergieText] = React.useState("");


	const handleNote = (e) => {
		const n = e.target.value
		setNote(n);
	};

  const handleNome = (event) => {
    const n = event.target.value
    setNome(n);
  };

  const handleDieta = (event) => {
    const d = event.target.value
    setDieta(d);
    if (d === "allergico") {
      setAllergieText("Specificare il tipo di allergia/intolleranza")
    } else {
      setAllergieText("")
    }
  };

  const i = props.id;

  return (
    <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} alignItems="center">
      <Grid item xs={6} md={4}>
        <TextField
          required
          //fontFamily='"Penna"'
          //color="#fff"
          inputProps={{style: {fontFamily: '"Penna"', fontSize: "1.8rem", fontWeight: "bold", color: "#fff"}}} 
          InputLabelProps={{style: {fontFamily: '"Penna"', fontSize: "1.8rem", fontWeight: "bold", color: "#fff"}}}  
          id={"nome_" + i}
          name="nome[]"
          label="Nome e Cognome"
          value={nome}
          variant="standard"
          sx={{ m: 1, fontFamily: '"Penna"', fontSize: "1.8rem", fontWeight: "bold", color: "#fff" }}
          onChange={(e) => handleNome(e)}
        />
      </Grid>
      <Grid item xs={6} md={4}>
        <FormControl variant="standard" sx={{ m: 1 }}>
          <InputLabel id="demo-simple-select-disabled-label" sx={{fontFamily: '"Penna"', fontSize: "1.8rem", fontWeight: "bold", color: "#fff"}}>Dieta</InputLabel>
          <Select
            labelId="Dieta"
            id={"dieta" + i}
            name="dieta[]"
            value={dieta}
            label="Dieta"
            sx={{ width: "180px", fontFamily: '"Penna"', fontSize: "1.8rem", fontWeight: "bold", color: "#fff"}}
            onChange={(e) => handleDieta(e)}
            
          >
            <MenuItem value={"tutto"} sx={{color: "#000", fontFamily: '"Penna"', fontSize: "1.8rem", fontWeight: "bold"}}>Mangio tutto</MenuItem>
            <MenuItem value={"bambini"} sx={{color: "#000", fontFamily: '"Penna"', fontSize: "1.8rem", fontWeight: "bold"}}>Menu Bambini</MenuItem>
            <MenuItem value={"infante"} sx={{color: "#000", fontFamily: '"Penna"', fontSize: "1.8rem", fontWeight: "bold"}}>Infante 0-2 anni</MenuItem>
            <MenuItem value={"vegetariano"} sx={{color: "#000", fontFamily: '"Penna"', fontSize: "1.8rem", fontWeight: "bold"}}>Vegetariano</MenuItem>
            <MenuItem value={"vegano"} sx={{color: "#000", fontFamily: '"Penna"', fontSize: "1.8rem", fontWeight: "bold"}}>Vegano</MenuItem>
            <MenuItem value={"celiaco"} sx={{color: "#000", fontFamily: '"Penna"', fontSize: "1.8rem", fontWeight: "bold"}}>Celiaco</MenuItem>
            <MenuItem value={"allergico"} sx={{color: "#000", fontFamily: '"Penna"', fontSize: "1.8rem", fontWeight: "bold"}}>Allergico/Introllerante</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} md={4}>
				<TextField
          FormHelperTextProps={{ sx: { color: 'red' } }}
          helperText={allergieText}
					id={"note" + i}
					label="Note"
          name="note[]"
					value={note}
					variant="standard"
          required={ allergieText ? true : false}
					sx={{ m: 1, width: "230px" }}
          inputProps={{style: {fontFamily: '"Penna"', fontSize: "1.8rem", fontWeight: "bold", color: "#fff"}}} 
          InputLabelProps={{style: {fontFamily: '"Penna"', fontSize: "1.8rem", fontWeight: "bold", color: "#fff"}}}  
					onChange={(e) => handleNote(e)}
				/>
        <Divider orientation='horizontal' variant='fullWidth' flexItem={true} component="hr" sx={{display: { md: 'none'}}} />
			</Grid>
      
    </Grid>
  )
}

export default Dieta;